import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Title } from 'components'
import { Table } from '@sar/component'

import { Row } from 'antd'
import { ModalForm, ProFormText, ProFormTreeSelect } from '@ant-design/pro-components'

async function fetchData(params, store) {
  const result = await store.externals.api.get(`/constant/source`, {
    params,
  })

  return {
    success: true,
    data: result,
  }
}

function Create ({ store, visible, handles, refreshConstant, onVisibleChange }) {
  return <ModalForm
    title='新增客户来源'
    open={visible}
    width={600}
    modalProps={{
      centered: true,
      destroyOnClose: true,
      maskClosable: false,
    }}
    layout='vertical'
    onOpenChange={onVisibleChange}
    onFinish={data => store.externals.api.post(`/constant`, data).then(() => handles.current.reload()).then(refreshConstant).then(R.T)}
  >
    <ProFormTreeSelect
      name='pid'
      label='上级数据'
      request={() => store.externals.api.get(`/constant/source`)}
      fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
    />

    <ProFormText
      name='source'
      label='来源名称'
      rules={[ { required: true, message: '请填写来源名称' } ]}
    />
  </ModalForm>
}

function Update ({ data, store, visible, handles, refreshConstant, onVisibleChange }) {
  return <ModalForm
    title='修改客户来源'
    open={visible}
    width={600}
    modalProps={{
      centered: true,
      destroyOnClose: true,
      maskClosable: false,
    }}
    layout='vertical'
    onOpenChange={onVisibleChange}
    request={() => store.externals.api.get(`/constant/${data.id}`)}
    onFinish={params => store.externals.api.put(`/constant/${data.id}`, params).then(() => onVisibleChange(false)).then(() => handles.current.reload()).then(refreshConstant).then(R.T)}
  >
    <ProFormTreeSelect
      name='pid'
      label='上级数据'
      request={() => store.externals.api.get(`/constant/source`)}
      fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
    />

    <ProFormText
      name='source'
      label='数据名称'
      rules={[ { required: true, message: '请填写数据名称' } ]}
    />
  </ModalForm>
}

export default function List ({ store, refreshConstant }) {
  const columns = [
    {
      title: '内容',
      dataIndex: 'source',
    },
  ]

  const actions = [
    {
      name: '新增',
      type: 'trigger',
      visible: () => store.identity.hasPermission('/data/list:create'),
      form: props => <Create {...props} store={store} refreshConstant={refreshConstant}/>,
    },
  ]

  const rowActions = [
    {
      name: '修改',
      visible: () => store.identity.hasPermission('/data/list:update'),
      form: props => <Update {...props} store={store} refreshConstant={refreshConstant}/>,
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个客户来源吗？',
      visible: () => store.identity.hasPermission('/data/list:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/constant/${data.id}`).then(() => handles.current.reload()).then(refreshConstant),
    },
  ]

  return <div className='p-4'>
    <Table
      title='客户来源管理'
      columns={columns}
      actions={actions}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      expandIcon={({ expanded, expandable, record, onExpand }) => {
        if (expandable == null) {
          return <div className='w-8 inline-block' />
        }

        return <div onClick={() => onExpand(record)} className='w-8 pl-2 inline-block cursor-pointer text-gray-600 hover:text-blue-600 transition ease-in-out'>
          <i className={`fa ${expanded ? 'fa-minus-square-o' : 'fa-plus-square-o'}`} />
        </div>
      }}
    />
  </div>
}
